import { EN } from './en.i18n';
import { DE } from './de.i18n';

export const SPS_TRANSLATIONS = { EN, DE };
